import { required, numeric, integer, helpers, requiredIf } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    branch: {
      id: {
        required: helpers.withMessage(i18n.global.t('Please select branch.'), required),
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
      },
      is_active: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required)
      },
      is_in_stock: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required)
      },
      price_override: {
        required: helpers.withMessage(i18n.global.t('Please enter a valid number for the price.'), requiredIf(formState.is_custom_price)),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the price.'), numeric)
      }
    }
  }
};
